// extracted by mini-css-extract-plugin
export default {"root":"column-picker_root__3x0-8"};